import React from "react";
import { Box, Paper, Typography, Stack, TextField } from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { searchService } from "../../api/services/searchService";
import { PageHeader, Loader, EmptyState, StatusChip } from "../../components/Common";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const q = params.get("q") || "";

  const { data, isLoading } = useQuery({
    queryKey: ["global-search", q],
    queryFn: () => searchService.global(q),
    enabled: q.length >= 2,
  });

  return (
    <Box>
      <PageHeader title="Search" subtitle="Across tickets and published knowledge base articles" />

      <TextField
        fullWidth placeholder="Search..." value={q} sx={{ mb: 3, maxWidth: 480 }}
        onChange={(e) => setParams(e.target.value ? { q: e.target.value } : {})}
      />

      {q.length < 2 ? (
        <EmptyState title="Type at least 2 characters to search" />
      ) : isLoading ? (
        <Loader />
      ) : (
        <Stack spacing={4}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
              Tickets ({data?.tickets?.length || 0})
            </Typography>
            {(!data?.tickets || data.tickets.length === 0) ? (
              <Typography variant="body2" color="text.secondary">No matching tickets.</Typography>
            ) : (
              <Stack spacing={1}>
                {data.tickets.map((t) => (
                  <Paper key={t.id} variant="outlined" sx={{ p: 1.5, cursor: "pointer" }} onClick={() => navigate(`/tickets/${t.id}`)}>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{t.ticket_number} — {t.subject}</Typography>
                  </Paper>
                ))}
              </Stack>
            )}
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
              Knowledge Base ({data?.kb_articles?.length || 0})
            </Typography>
            {(!data?.kb_articles || data.kb_articles.length === 0) ? (
              <Typography variant="body2" color="text.secondary">No matching articles.</Typography>
            ) : (
              <Stack spacing={1}>
                {data.kb_articles.map((a) => (
                  <Paper key={a.id} variant="outlined" sx={{ p: 1.5, display: "flex", justifyContent: "space-between", cursor: "pointer" }} onClick={() => navigate(`/kb/${a.id}`)}>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{a.title}</Typography>
                    <StatusChip value={a.status} />
                  </Paper>
                ))}
              </Stack>
            )}
          </Box>
        </Stack>
      )}
    </Box>
  );
}
